import { useRef,useEffect } from 'react';
import ContactBtn from './ContactBtn';
import EmptyModal from './EmptyModal';
import  styles from './HowToMakeNs.module.css';
import figureVideo from '../assets/namespace_2k_4096.mp4';

const makeItems=[
    "Namespace 이름",
    "용도",
    "공개범위",
]

export default function HowToMakeNs({onClose}){
    const figureRef=useRef(null);

    useEffect(() => {
      if(figureRef.current.played.length === 0 ) figureRef.current.play();

      const timer = setInterval(() => {
        let figureRefPlay=figureRef.current.play();
        if (figureRefPlay !== undefined) { figureRefPlay.then((_) => {}).catch((error) => {}); }
      }, 500);
      return () => {
        clearInterval(timer);
      };
    }, []);

    return(
        <EmptyModal onClose={()=>onClose()}>
        <div className={styles['main']}>
            <div className={styles["figure"]}>
                <video ref={figureRef} muted className={styles["figure-video"]}>
                    <source src={figureVideo} type="video/mp4"/>
                </video>
            </div>
            <div className={styles['body']}>
                <div className={styles['info']}>
                    <div className={styles['info-title']}>
                        <div className={styles['info-title-icon']}></div>
                        <span>How to create namespace</span>
                    </div>
                    <span className={styles['info-intro']}>
                        Namespace 생성을 위해 아래의 양식에 맞춰 관리자에게 메일로
                        <br></br>
                        요청주시면, 검토 후 생성해 드립니다.
                    </span>
                    <div className={styles['info-item-wrap']}>
                        {makeItems.map((item,index)=>(
                        <>
                        <div className={styles['info-item']}>
                            <div className={styles['info-item-icon']}></div>
                            <span key={index}>{item}</span>
                        </div>
                        {index===2 && <span className={styles['info-item-visiblity']}>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Public: 멤버 외 사용자 검색 및 참여 신청 가능
                        <br></br>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Private: 초대 외 참여 불가능
                        </span>}
                        </>
                        ))}
                    </div>
                    <ContactBtn/>
                </div>
            </div>
        </div>
        </EmptyModal>
    )
}